class Utils {
    /* 获取地址栏参数 */
    getSearchParams(queryName) {
            if (window.location.href.indexOf("?") < 0) return null;
            var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
            var r = null;
            if (window.location.search) {
                r = window.location.search.substr(1).match(reg);
            } else {
                r = window.location.hash.split("?")[1].match(reg);
            }
            if (r != null) {
                return decodeURI(r[2]);
            } else {
                return null;
            }
        }
        //判断是否是企业微信打开
    is_qyweixin() {
        return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    }
}
const utils = new Utils();
export default utils;